<template>

	<div id="body" class="fixed-sidebar" :class="{'mini-navbar':config.minimize}">

		<div id="wrapper">

			<Navigation/>

			<div id="page-wrapper" class="gray-bg" @click="blankClick">

				<TopNavBar/>

				<div class="mt10 pb40">

					<div class="mb10">

						<a class="mr10" @click="$router.go(-1)">
							<i class="fa fa-arrow-left"></i>
						</a>

						<router-link to="/by">
							首页
						</router-link>

						<span v-for="b in $store.state.breadcrumbs">
              <span>/</span>
							<router-link v-if="b.name !== $store.state.route.name" :to="b">
                {{b.title}}
              </router-link>
							<span v-if="b.name === $store.state.route.name">
								{{b.title}}
							</span>

            </span>

					</div>
					<router-view></router-view>

				</div>
			</div>
		</div>

	</div>


</template>

<script>


	import Navigation from './view/layout/Navigation.vue'
	import TopNavBar from './view/layout/TopNavBar.vue'
	import enquire from "enquire.js/dist/enquire";
	import {mapActions} from 'vuex'

	export default {

		beforeMount(){

		},
		computed: {
			config () {
				return this.$store.state.config
			}
		},
		components: {
			Navigation,
			TopNavBar
		},
		methods: {
			...mapActions([
				'toggleMinimize',
				'setMobile'
			]),
			blankClick(){
				if (this.config.mobile) {
					if (!this.config.minimize) {
						this.toggleMinimize();
					}
				}
			}
		},
		created(){

		},
		mounted(){
			let that = this;
			enquire.register("(max-width: 768px)", {
				match: function () {
					that.setMobile(true);
				},
				unmatch: function () {
					that.setMobile(false);
				}
			});
		}
	}

</script>

<style lang="less" rel="stylesheet/less">

</style>


// WEBPACK FOOTER //
// Frame.vue?62b1c661